import React, { Component } from "react";
import { connect } from "react-redux";

import Subscribing from "../Subscribing/Subscribing";
import Subscribe from "../Subscribe/Subscribe";
import SubscribeComplete from "../SubscribeComplete/SubscribeComplete";

import styles from "./AuthorSubscribe.css";

class SubscribeToNewsletter extends Component {

  onSubscribe = (email) => {
    this.props.onSubscribed(email, this.props.subscription);
  };


  render() {
    const { subscription } = this.props;

    return (
      <div className={styles.subscribe}>
        {
          !this.props.isLoggedIn && this.props.thanks ?
            <SubscribeComplete subscription={subscription}/> :
            this.props.subscribing ?
              <Subscribing subscription={subscription} onSubscribe={this.onSubscribe}/> :
              <Subscribe
                subscription={subscription}
                onClickSubscribe={this.props.isLoggedIn ? this.onSubscribe : this.props.onSubscribing}/>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: !!state.authDrawer.authToken, // TODO: implement this when user stuff is done
  };
};

export default connect(mapStateToProps)(SubscribeToNewsletter);



// WEBPACK FOOTER //
// ./src/author/components/AuthorSubscribe/SubscribeToNewsletter.js